import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { ENTITY_TYPES } from '../../../services/EntityService';
import { createTypeUtils } from '../type-filter/TypeFilterHelper';

export const VCENTER_TYPE = 'vcenter';
export const HYPERVISOR_TYPE = ENTITY_TYPES.HYPERVISOR;
export const VIRTUALMACHINE_TYPE = ENTITY_TYPES.VIRTUAL_MACHINE;

export const SUB_TYPE_NAMES = {
    [VCENTER_TYPE]: i18n._(t`vCenter`),
    [HYPERVISOR_TYPE]: i18n._(t`Hypervisor`),
    [VIRTUALMACHINE_TYPE]: i18n._(t`Virtual Machine`),
};

export const {
    objects: SUB_TYPE_OBJECTS,
    values: SUB_TYPE_VALUES,
    getName: getSubTypeName,
} = createTypeUtils(SUB_TYPE_NAMES);
